var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",{"transform":"translate(-16 -21) translate(16 21)"},React.createElement("g",null,React.createElement("path",{"d":"M16 10v2H0v-2h16zm0-5v2H0V5h16zm0-5v2H0V0h16z","transform":"translate(4 6)"}))))));
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Menu;

Menu.default = Menu;
